import type { AgentTaskRequest } from '@wave/shared';
import { useAskAgent } from '../api/mutations';
import { hasRight, useAuthStore } from '../auth/store';
import { btnGhostSm } from '../lib/styles';

/**
 * «Разобрать агентом»: ставит задачу агенту-аудитору; ответ придёт в чат
 * алертов (ADM Wave) ответом на сообщение о запросе. Видна с правом audit.view.
 */
export function AskAgentButton({ request, label = '🤖 Разобрать агентом' }: { request: AgentTaskRequest; label?: string }) {
  const canView = hasRight(useAuthStore((s) => s.rights), 'audit.view');
  const ask = useAskAgent();
  if (!canView) return null;
  if (ask.isSuccess) {
    return (
      <span className="text-xs text-success">
        {ask.data.created ? 'Поставлено агенту' : 'Уже в очереди'} — ответ придёт в чат алертов (~5 мин)
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-2">
      <button type="button" className={btnGhostSm} disabled={ask.isPending} onClick={() => ask.mutate(request)}>
        {ask.isPending ? 'Ставлю…' : label}
      </button>
      {ask.isError && <span className="text-xs text-danger">Не удалось: {ask.error instanceof Error ? ask.error.message : 'ошибка'}</span>}
    </span>
  );
}
